'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))

module.exports = class pureHtmlWidget extends Base {

	onInit() {

		if (typeof this._data !== 'object') {
			this._data = {html: this._data}
		}

		this.editable = this._widget.querySelector('.content-editable')
		this.editable.setAttribute('contenteditable', '')
		this.editable.focus()

		this.btns = {}
		this.allButtons()

		this.onchange()
		this.listener(this.editable)

	}

	onDestroy() {
		this.editable.removeAttribute('contenteditable')
	}

	onSave() {
		this.editable.removeAttribute('contenteditable')
		this.listenerRemove(this.editable)
	}

	allButtons() {

		function i(text) {
			return '<i class="material-icons">' + text + '</i>'
		}

		function space() {
			let el = document.createElement('span')
			el.className = 'btn-space'
			return el
		}

		let buttons = [
			this.addButton(i('format_align_left'), 'justifyLeft'),
			this.addButton(i('format_align_center'), 'justifyCenter'),
			this.addButton(i('format_align_right'), 'justifyRight'),
			this.addButton(i('format_align_justify'), 'justifyFull'),
			space(),
			this.addButton(i('format_bold'), 'bold'),
			this.addButton(i('format_italic'), 'italic'),
			this.addButton(i('format_underline'), 'underline'),
			this.addButton(i('format_size'), 'fontSize', '5'),
			this.addButton(i('format_size'), 'fontSize', '6'),
			this.addButton(i('format_size'), 'fontSize', '7'),
			this.addButton(i('link'), (active) => {
				if (active) {
					this._doc.execCommand('unlink')
				} else {
					this.formLink()
				}
			}, 'anchor'),
			space(),
			this.addButton(i('format_list_bulleted'), 'insertUnorderedList'),
			this.addButton(i('format_list_numbered'), 'insertOrderedList'),
			this.addButton(i('format_indent_increase'), 'indent'),
			this.addButton(i('format_indent_decrease'), 'outdent'),
		]

		buttons.forEach((btn) => {
			this._elemButtons.appendChild(btn)
		})

	}

	addButton(text, command, block) {
		let button = document.createElement('button')
		button.className = 'formater'
		button.innerHTML = text
		button.onclick = () => {
			if (typeof command === 'string') {
				this._doc.execCommand(command, false, block)
			}
			if (typeof command === 'function') {
				command(button.hasAttribute('active'))
			}
			this.onchange()
		}
		button.active = (is) => {
			if (is) { button.setAttribute('active', '') }
			else { button.removeAttribute('active') }
		}
		this.btns[block || command] = button
		return button
	}

	getSelection() {
		return this._doc.defaultView.getSelection()
	}

	containsNode(name, node) {

		if (!node) {
			if (!this.getSelection().focusNode) { return }
			node = this.getSelection().focusNode.parentNode
		}

		if (node.nodeName === 'BODY') {
			return
		}

		if (!node || node.hasAttribute('contenteditable')) {
			return false
		}
		if (node.nodeName === name) {
			return true
		}
		return this.containsNode(name, node.parentNode)
	}

	onchange() {

		let isSelected = () => {
			let s = this.getSelection()
			return s.anchorOffset - s.focusOffset !== 0
		}


		this.btns.bold.active(this.containsNode('B'))
		this.btns.italic.active(this.containsNode('I'))
		this.btns.underline.active(this.containsNode('U'))
		this.btns.anchor.active(this.containsNode('A'))

		this.btns.bold.disabled = !isSelected()
		this.btns.italic.disabled = !isSelected()
		this.btns.underline.disabled = !isSelected()

		// this.btns.P.disabled = this.containsNode('LI');
		// this.btns.H1.disabled = this.containsNode('LI');
		// this.btns.H2.disabled = this.containsNode('LI');
		// this.btns.H3.disabled = this.containsNode('LI');
		// this.btns.H4.disabled = this.containsNode('LI');
		// this.btns.H5.disabled = this.containsNode('LI');
		// this.btns.H6.disabled = this.containsNode('LI');

		// this.btns.insertUnorderedList.active(this.containsNode('UL'));
		// this.btns.insertOrderedList.active(this.containsNode('OL'));
		// this.btns.P.active(this.containsNode('P'));
		// this.btns.H1.active(this.containsNode('H1'));
		// this.btns.H2.active(this.containsNode('H2'));
		// this.btns.H3.active(this.containsNode('H3'));
		// this.btns.H4.active(this.containsNode('H4'));
		// this.btns.H5.active(this.containsNode('H5'));
		// this.btns.H6.active(this.containsNode('H6'));

		this._data.html = this.editable.innerHTML


	}

	listener(element) {
		element.addEventListener("blur", (e) => { this.onchange(e) })
		element.addEventListener("keyup", (e) => { this.onchange(e) })
		element.addEventListener("paste", (e) => { this.onpaste(e) })
		element.addEventListener("copy", (e) => { this.onchange(e) })
		element.addEventListener("cut", (e) => { this.onchange(e) })
		element.addEventListener("delete", (e) => { this.onchange(e) })
		element.addEventListener("mouseup", (e) => { this.onchange(e) })
		element.addEventListener("click", (e) => { this.onchange(e) })
	}

	listenerRemove(element) {
		const new_element = element.cloneNode(true)
		element.parentNode.replaceChild(new_element, element)
	}

	onpaste(e) {
		e.preventDefault()
		let text = e.clipboardData.getData('text/html') ||
			e.clipboardData.getData('text')
		let cleantext = this.clearPaste(text)
		this._doc.execCommand('insertHTML', false, cleantext)
		this.onchange(e)
	}

	clearPaste(s) {
		// remove tag attributes
		s = s.replace(/<([a-z][a-z0-9]*)[^>]*?(\/?)>/igm, '<$1$2>')
		// remove scripts
		s = s.replace(/<script.*?>.*?<\/script>/igm, '')
		s = s.replace(/<style.*?>.*?<\/style>/igm, '')
		s = s.replace(/<meta.*?>/igm, '')
		s = s.replace(/<link.*?>/igm, '');
		s = s.replace(/<!--.*?-->/igm, '');

		[
			'span', 'em', 'strong', 'a',
		].forEach(tag => {
			s = this.removePasteTag(s, tag)
		});

		[
			'code', 'pre',
			'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
			'p', 'blockquote',
		].forEach(tag => {
			s = this.replacePasteTag(s, tag, 'div')
		})
		return s
	}

	removePasteTag(s, name) {
		let start = new RegExp('<' + name + '.*?>', 'igm')
		let end = new RegExp('</' + name + '>', 'igm')
		s = s.replace(start, '')
		s = s.replace(end, '')
		return s
	}

	replacePasteTag(s, name, name2) {
		let start = new RegExp('<(' + name + ').*?>', 'igm')
		let end = new RegExp('</(' + name + ')>', 'igm')
		s = s.replace(start, '<' + name2 + '>')
		s = s.replace(end, '</' + name2 + '>')
		return s
	}

	formLink() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		let url = document.createElement('input')
		url.setAttribute('type', url)
		url.value = 'http://'

		div.appendChild(forms.input('Text', text))
		div.appendChild(forms.input('Url', url))

		let s = this.getSelection()
		if (s.extentOffset !== s.baseOffset) {
			text.value = s.toString().replace(/\n/ig, '')
		}

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Vlozit odkaz'
		button.onclick = () => {
			if (!url.value) { return }
			if (text.value) {
				this._doc.execCommand('insertHTML', false,
					'<a href="' + url.value + '" target="_blank">' + text.value + '</a>')
			} else {
				this._doc.execCommand('createLink', false, url.value)
			}
			this.onchange()
			modal.hide()
		}
		block.appendChild(forms.actions(button))

		let title = 'Pridat odkaz'
		modal.show(title, block).then(() => { text.focus() })

	}


}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/pure-html/pure-html.edit.js
// module id = 488
// module chunks = 0